import { useUIOnlyStore } from '@/Store/storeUI';
import { useConfigurationStore } from '@/Store/storeConfiguration';

export function deleteEl() {
    const selectedEl = JSON.parse(JSON.stringify(useUIOnlyStore().getSelectedSceneObject));
    console.log(selectedEl);
    if (!selectedEl.uuid) {
        return;
    }

    if (selectedEl.label === 'Дверь') {
        useConfigurationStore().removeDoorByUUID(selectedEl.uuid);
    } else if (selectedEl.label === 'Окно') {
        useConfigurationStore().removeWindowByUUID(selectedEl.uuid);
    } else if (selectedEl.label === 'Куб') {
        useConfigurationStore().removeBoxByUUID(selectedEl.uuid);
    } else {
        useConfigurationStore().removeByUUID(selectedEl.label,selectedEl.uuid);
    }
    useUIOnlyStore().unselect();
}
